import { render, staticRenderFns } from "./authorIntro.vue?vue&type=template&id=5f888dc3&scoped=true&"
import script from "./authorIntro.vue?vue&type=script&lang=js&"
export * from "./authorIntro.vue?vue&type=script&lang=js&"
import style0 from "./authorIntro.vue?vue&type=style&index=0&id=5f888dc3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f888dc3",
  null
  
)

export default component.exports